import React from 'react';

const RightArrowAlt = ({ stroke = '#4E4C55' }: { stroke?: string }) => {
    return (
        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.25 9.25L5.75 5L1.25 0.75"
                stroke={stroke}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default RightArrowAlt;
